document.addEventListener("DOMContentLoaded", function() {

    // Google mapa
    //============
    (function () {

        // incializace mapy v detailu nemovitosti podle kliknuti na tlacitko
        const mapDetailButton = document.querySelector('[data-detail-map-button]');
        const mapDetailContent = document.querySelector('[data-detail-map-content]');
        const mapDetailPlaceholder = document.querySelector('[data-detail-map-placeholder]');

        if (mapDetailButton && mapDetailContent && mapDetailPlaceholder) {
            mapDetailButton.addEventListener('click', () => {
                mapDetailContent.style.display = 'block';
                mapDetailPlaceholder.style.display = 'none';
                initGoogleMaps();
            });
        }

        // kontrola jestli ma nemovitost fotogalerii - jinak se musi aktivovat mapa
        const hasGallery = document.querySelector('[data-detail-gallery]');
        if (!hasGallery && mapDetailButton && mapDetailContent && mapDetailPlaceholder) {
            mapDetailContent.style.display = 'block';
            mapDetailPlaceholder.style.display = 'none';
            initGoogleMaps();
        }

        function initGoogleMaps () {
                if ('undefined' === typeof window.google || 'undefined' === typeof window.google.maps)
                    return;

                let maps = window.google.maps;

                document.querySelectorAll('.GoogleMap').forEach(function (el) {
                    const map = el;
                    map.dataStorage = {};

                    const lat = parseFloat(map.querySelector('.Lat') !== null ? map.querySelector('.Lat').value : null);
                    const lng = parseFloat(map.querySelector('.Lng') !== null ? map.querySelector('.Lng').value : null);
                    const defaultLatLng = new maps.LatLng(49.819455, 15.470514);

                    let zoom = map.querySelector('.Zoom') !== null ? parseInt(map.querySelector('.Zoom').value) : 16;

                    if (isNaN(zoom))
                        zoom = 16;

                    const line = [];
                    const exterior = [];
                    const address = map.querySelector('.Address') !== null ? map.querySelector('.Address').value : '';

                    map.querySelectorAll('.line').forEach(function (el) {
                        line.push(JSON.parse(el.value));
                    });

                    map.querySelectorAll('.exterior').forEach(function (el) {
                        exterior.push(JSON.parse(el.value));
                    });

                    const fitBounds = function (bounds, map, zoom) {
                        map.fitBounds(bounds);

                        if (typeof zoom !== "undefined" && zoom) {
                            const zoomChangeBoundsListener = google.maps.event.addListenerOnce(map, 'bounds_changed', function (event) {
                                if (this.getZoom())
                                    this.setZoom(zoom);
                            });
                            setTimeout(function () {
                                google.maps.event.removeListener(zoomChangeBoundsListener)
                            }, 2000);
                        }
                    };

                    const showMap = function (latLng, zoom) {
                        if (isNaN(zoom) || 'undefined' === typeof zoom)
                            zoom = 14;

                        let gmMap = new maps.Map(el, {
                            'zoom': zoom,
                            'center': latLng,
                            'mapTypeId': maps.MapTypeId.ROADMAP,
                            'disableDefaultUI': true,
                            'zoomControl': true,
                            'zoomControlOptions': {'style': maps.ZoomControlStyle.SMALL},
                            'draggable': true,
                            'scrollwheel': false,
                            //'disableDoubleClickZoom': true,
                            'keyboardShortcuts': false,
                        });

                        if (typeof window.maps_colors != 'undefined')
                            gmMap.set('styles', window.maps_colors);

                        let gmPolygons = [],
                            gmMarkers = [],
                            gmBounds = new google.maps.LatLngBounds();

                        map.dataStorage = {
                            polygons: gmPolygons,
                            markers: gmMarkers,
                            bounds: gmBounds
                        };

                        if (line.length > 0) {
                            for (let i in line) {

                                let gPolygon = new google.maps.Polyline({
                                    path: line[i],
                                    geodesic: true,
                                    strokeColor: window.setting.FRONTEND_SETTING_NEMOVITOST_MAP_POLYGON_STROKE,
                                    strokeOpacity: 1.0,
                                    strokeWeight: 2
                                });

                                for (let j in line[i])
                                    gmBounds.extend(new google.maps.LatLng(line[i][j]));

                                gPolygon.setMap(gmMap);
                                gmPolygons.push(gPolygon);
                            }

                            fitBounds(gmBounds, gmMap, zoom);
                        } else if (exterior.length > 0) {
                            for (let i in exterior) {

                                let gPolygon = new google.maps.Polygon({
                                    paths: exterior[i],
                                    strokeColor: window.setting.FRONTEND_SETTING_NEMOVITOST_MAP_POLYGON_STROKE,
                                    strokeOpacity: 0.5,
                                    strokeWeight: 2,
                                    fillColor: window.setting.FRONTEND_SETTING_NEMOVITOST_MAP_POLYGON_FILL,
                                    fillOpacity: 0.1
                                });
                                gPolygon.setMap(gmMap);
                                gmPolygons.push(gPolygon);

                                for (let j in exterior[i])
                                    gmBounds.extend(new google.maps.LatLng(exterior[i][j]));
                            }
                            fitBounds(gmBounds, gmMap, zoom);
                        } else {
                            if (typeof window.maps_marker_icon != 'undefined' && typeof window.maps_marker_icon_anchor != 'undefined')
                                window.maps_marker_icon.anchor = new maps.Point(window.maps_marker_icon_anchor[0], window.maps_marker_icon_anchor[1]);

                            gmMarkers.push(new maps.Marker({
                                'map': gmMap,
                                'position': latLng,
                                'icon': (typeof window.maps_marker_icon != 'undefined' ? window.maps_marker_icon : null)
                            }));

                            map.dataStorage.zoom = zoom;
                        }

                        map.dataStorage.map = gmMap;
                        map.dataStorage.loading = false;
                    };

                    if (!isNaN(lat) && !isNaN(lng)) {
                        showMap(new maps.LatLng(lat, lng), zoom);
                    } else if (line.length > 0) {
                        showMap(defaultLatLng, zoom);
                    } else if (exterior.length > 0) {
                        showMap(defaultLatLng, zoom);
                    } else if (address) {
                        let gmGeocoder = new maps.Geocoder();
                        map.dataStorage.loading = true;
                        gmGeocoder.geocode({
                            'address': address,
                            'language': poskiLocale.locale
                        }, function (results, status) {
                            if (maps.GeocoderStatus.ZERO_RESULTS === status)
                                return;

                            if (maps.GeocoderStatus.OK !== status)
                                return;

                            // some() místo forEach(): return ve forEach cyklus neukončí a mapa skončila na posledním výsledku místo prvního
                            results.some(function (v) {
                                // @TODO Podle dokumentace nemusí být komponenty vždy seřazeny stejně, tzn. při zpracování jak to tady je to může vracet rozdílné markery/polygony.
                                // Navíc tím, jak se to tady zpracovává to může jednou zaměřit na ulici, potom město, potom XXX.
                                // @see https://developers.google.com/maps/documentation/geocoding/requests-geocoding#json:~:text=Note%20the%20following%20facts%20about%20the%20address_components%5B%5D%20array%3A
                                if (![
                                    'neighborhood', // "A named neighborhood" = nějaká část města (?), např. Karlín, Vinohrady, Poruba, Slezská Ostrava,...
                                    'street_address', // adresa na nějaké ulici
                                    'route', // ulice
                                    'locality', // město geograficky
                                    'political' // nějaký oblast/polygon na politické mapě (nejčastěji asi město)
                                ].includes(v.types[0]))
                                    return;

                                showMap(v.geometry.location, zoom);
                                return true;
                            });
                        });
                    }
                });

                (function () {
                    let zalozkaMapa = document.querySelector('.JS-responsiveTabs a[href="#mapa"]');
                    if (typeof (zalozkaMapa) === 'undefined' || zalozkaMapa === null) {
                        return;
                    }

                    zalozkaMapa.addEventListener("click", function () {
                        setTimeout(() => {
                            let map = document.querySelector('.GoogleMap');
                            let gmMap = map.dataStorage.map;
                            let zoom = map.querySelector('.Zoom') !== null ? parseInt(map.querySelector('.Zoom').value) : 16;

                            if (isNaN(zoom)) {
                                zoom = 16;
                            }

                            gmMap.setZoom(zoom);
                        }, 500);

                    });
                }());

                (function () { // resize mapy dev. projekty
                    let zalozkaLokatita = document.querySelector('.JS-responsiveTabs a[href="#lokalita"]');
                    if (typeof (zalozkaLokatita) === 'undefined' || zalozkaLokatita === null)
                        return;

                    zalozkaLokatita.addEventListener("click", function () {
                        let map = document.querySelector('.GoogleMap');
                        if (map) {
                            let gmMap = map.dataStorage.map;
                            window.google.maps.event.trigger(gmMap, 'resize');
                            if (map.dataStorage.markers && map.dataStorage.markers.length > 0) {
                                let marker = map.dataStorage.markers[0];
                                gmMap.setCenter(marker.position);
                            }
                        }
                    });
                }());

                zvyrazneniMapy();
            }
    }());

    function zvyrazneniMapy() { // zvyraznovani na mapce v prehledu
        let map = document.querySelector('#Map'),
            mapaHolder = document.querySelector('#MapaHolder'),
            ul = document.querySelector('#Kraje');

        const mouseHandler = function (ev) {
            let target = ev.target;
            if (!target.matches('area') && !target.matches('a'))
                return;

            mapaHolder.querySelectorAll('span').forEach(function (el) {
                el.classList.remove('active');
            });

            if ('mouseover' === ev.type)
                mapaHolder.querySelector('span.' + target.getAttribute('class').replace(/.*\b(Kraj\w+)\b.*/, '$1')).classList.add('active');
        };

        if(typeof(map) != 'undefined' && map != null) {
            map.addEventListener("mouseover", mouseHandler);
            map.addEventListener("mouseout", mouseHandler);
        }

        if(typeof(ul) != 'undefined' && ul != null) {
            ul.addEventListener("mouseover", mouseHandler);
            ul.addEventListener("mouseout", mouseHandler);
        }
    }
});